import { BodeScreenFormStrategy } from "./bode";
import { CascadeScreenFormStrategy } from "./cascade";
import { NyquistScreenFormStrategy } from "./nyquist";
import { OrbitScreenFormStrategy } from "./orbit";
import type { ISpeedScreenFormStrategiesPull } from "./types";

export const SPEED_SCREEN_FORM_STRATEGIES: ISpeedScreenFormStrategiesPull = {
  orbit: OrbitScreenFormStrategy,
  nyquist: NyquistScreenFormStrategy,
  bode: BodeScreenFormStrategy,
  cascade: CascadeScreenFormStrategy,
};
